import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import axios, { CancelToken } from "axios";
import { usePagination } from "hooks";
import { PAYMENT, PAYMENT_CONVENIENCE_STORE } from "../../../../constants/api";

const makeTransactionsRequest = async (source, limit, offset) => {
  const params = {
    type: "STORE",
    limit,
    offset,
  };

  try {
    const response = await axios.get(PAYMENT, {
      params,
      cancelToken: source.token, // this is just because the componet renders 2 times once we fix that issue we wont need this
    });

    return response;
  } catch (error) {
    return error;
  }
};

const transactionsDataMapper = (data, formatDate) => {
  const rows = data.map((item) => {
    const status =
      new Date().getTime() > new Date(item.expiration_date).getTime() &&
      item.status !== 4
        ? 3
        : item.status;
    return {
      key: item.transaction,
      date: formatDate(item.timestamp, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }),
      type: item.store.name,
      status: status,
      url: item.url,
      amount: item?.total?.amount,
      reference: item?.reference?.description,
    };
  });

  return { rows };
};

// maybe split into useFilters useTable
const useCashPayment = () => {
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState({});
  const [createBallotError, setCreateBallotError] = useState("");
  const { paginationConfig } = usePagination(paymentData?.total);

  const intl = useIntl();

  useEffect(() => {
    const source = CancelToken.source();
    getTransactionsData(source);

    return () => {
      source.cancel("Component unmounted");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationConfig.limit, paginationConfig.offset]);

  const getTransactionsData = async (source) => {
    setLoading(true);
    const response = await makeTransactionsRequest(
      source,
      paginationConfig.limit,
      paginationConfig.offset
    );

    if (response?.data?.success) {
      const data = response.data.result;
      setPaymentData({
        rows: transactionsDataMapper(data.operations, intl.formatDate),
        total: data.total,
      });

      setLoading(false);
    } else {
      console.error("Backend error", response);
    }
  };

  const createBallot = async (body) => {
    setCreateBallotError("");

    let newBallot = null;

    try {
      const response = await axios.post(PAYMENT_CONVENIENCE_STORE, body);

      const source = CancelToken.source();
      getTransactionsData(source);

      newBallot = response.data;
    } catch (err) {
      setCreateBallotError(
        err.response?.data?.error?.message ??
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }

    return newBallot;
  };

  useEffect(() => {
    const source = CancelToken.source();

    return () => {
      source.cancel("Component unmounted");
    };
  }, []);

  return {
    loading,
    transactions: paymentData.rows,
    paginationConfig,
    createBallot,
    createBallotError,
  };
};

export default useCashPayment;
